import React from 'react';
import {Text, View} from 'react-native';

const TicketScreen: React.FC = () => {
  return (
    <View>
      <Text>TicketScreen</Text>
    </View>
  );
};

export default TicketScreen;
